module.exports = __webpack_public_path__ + "static/media/reinama.24b63952.png";